import { default as Select } from './select';
import { default as SelectItem } from './item'; // This allows us to add `Item` as a static property of `Select`, without merging the two files together

var Index = Select;
Index.Item = SelectItem;
export default Index;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/select/index.js
// module id = 1037
// module chunks = 0